





















// vue
import { defineComponent } from '@vue/composition-api';

// components
import Surface from '@/vue3/components/Surface.vue';

// primevue
import Button from 'primevue/button';

export default defineComponent({
    components: {
        Button,
        Surface,
    },
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        tools: {
            type: Array,
            default: () => [],
        },
    },
    setup() {
        return {};
    },
});
